<div class="container">
    <form [formGroup]="column">
        <mat-form-field>
            <mat-label>Header</mat-label>
            <input matInput formControlName="HeaderTxt" [readonly]="this.Field=='select'">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Field</mat-label>
            <mat-select formControlName="Field">
                <mat-option *ngFor="let f of fieldlist" [value]="f">{{f}}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>
